<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'
import axios from 'axios'

import EventBus from '@/event-bus'
import ObservationsWrapper from '@/components/teacher/ObservationsWrapper'

const apiBase = API_APP_PATH + '/v1'

@Component({
    components: {
        ObservationsWrapper
    },
    computed: {
        ...mapGetters({
            userRole: "getUserRole",
            id: "getEmployeeId",
            fiscalYear: "getFiscalYear"
        })
    }
})

export default class AdminObservationsContainer extends Vue {
    teacherInfo = null
    observations = null
    loading = false
    
    async mounted() {
        EventBus.$on('loading', () => {
            this.loading = true
        })
        try {
            this.loading = true
        
            const id = this.$route.params.id ? this.$route.params.id : this.id
            
            const { data: teacher } = await axios.get(
                `${apiBase}/data/teacher/app/ge/info/id/${id}`
            )
            const { data: observations } = await axios.get(
                `${apiBase}/data/teacher/observations/${id}`
            )
            const { data: components } = await axios.get(
                `${apiBase}/data/teacher/component/${id}`
            )

            this.loading = false

            this.teacherInfo = teacher
            
            const _observations = observations
            this.observations = _observations.map(observation => {
                observation.componentsMeasured = components.filter(component =>
                    component.MOTPID === observation.MOTPID
                ).sort(function(a, b) {
                    return a.MOTPComponentDescription < b.MOTPComponentDescription
                    ? -1
                    : 1
                })
                return observation
            })

            this.loading = false
        } catch(err) {
            console.log(err)
        }
    }
}
</script>

<template>
    <div>
        <div 
            v-if="loading"
            class="loading"
        >
            <p>Loading...</p>
        </div>
        <div 
            v-else
        >
            <ObservationsWrapper v-if="teacherInfo && teacherInfo.length > 0"
                :user-role="userRole"
                :fiscal-year="fiscalYear"
                :teacher-info="teacherInfo"
                :observations="observations"
                :id="id">
            </ObservationsWrapper>
            <h2 v-if="teacherInfo && teacherInfo.length === 0">
                You are not authorized to view this teacher's observations data.
            </h2>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .loading {
        p {
            text-align: center;
            font-family: Arial, sans-serif;
        }
        @media all and (min-width: 600px) {
            min-height: 500px;
        }
    }
</style>